<template>
  <div class="d-flex flex-column">
    <h5>Melding</h5>
    <p class="mb-0"><b>Opmerking</b></p>
    <p
      v-if="isLoading"
      class="placeholder"
    >
      Placeholder tekst tijdens laden.
    </p>
    <template
      v-else
      class="message my-1"
    >
      <template
        v-if="isEditing"
      >
        <material-textarea
          v-model="editMessage"
        />
      </template>
      <p
        v-else
      >
      {{ report?.message ?? '' }}
      </p>
    </template>
  </div>
</template>

<script>
import MaterialTextarea from '@/components/MaterialTextarea.vue';
import ReportDetailStore from '@/store/pages/Report/report-detail-store';
import ReportEditStore from '@/store/pages/Report/report-edit-store';

export default {
  components: {
    MaterialTextarea,
  },

  computed: {
    isLoading: () => ReportDetailStore.getters.isLoading,
    isEditing: () => ReportEditStore.getters.isEditing,
    report: () => ReportDetailStore.getters.report,
    editMessage: {
      get: () => ReportEditStore.getters.editingReport.message,
      set: (v) => ReportEditStore.dispatch('updateEditingMessage', v),
    }
  },
}
</script>

<style scoped>
b {
  font-size: 1.2em;
}</style>
